import React from 'react';
import { Button, ButtonGroup } from '@superops/ui-design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  DeleteModal,
  getCurrentUserHook,
  getTranslatedText
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';

const TimesheetActionCell = (props) => {
  const intl = useIntl();
  const user = getCurrentUserHook();
  const { cell } = props;
  const { itemId, technician, status } = cell.row?.original;
  const approved = status !== 'PENDING';

  return (
    !approved &&
    technician?.userId === user?.userId && (
      <div className="action-button">
        <ButtonGroup>
          <DeleteModal
            modalActivator={
              <Button
                icon={
                  <div id="delete-modal">
                    <SVGIcon name="Delete" color="#EC9E9E" />
                  </div>
                }
              />
            }
            title={getTranslatedText(intl, 'worklog.unknown.delete.title')}
            handleDeleteConfirmation={() => {
              cell.column?.actions?.deleteWorklogEntry({
                variables: {
                  deleteWorklogInput: {
                    itemId: itemId
                  }
                }
              });
            }}
            // handleDeleteConfirmation={handleDelete}
            description={getTranslatedText(
              intl,
              'worklog.unknown.delete.description'
            )}
          />
        </ButtonGroup>
      </div>
    )
  );
};

export default TimesheetActionCell;
